export default {
  'component.globalHeader.search': 'Suchen',
  'component.globalHeader.search.example1': 'Suchbeispiel 1',
  'component.globalHeader.search.example2': 'Suchbeispiel 2',
  'component.globalHeader.search.example3': 'Suchbeispiel 3',
  'component.globalHeader.help': 'Hilfe',
  'component.globalHeader.notification': 'Benachrichtigung',
  'component.globalHeader.notification.empty':
    'Sie haben alle Benachrichtigungen angesehen.',
  'component.globalHeader.message': 'Nachricht',
  'component.globalHeader.message.empty': 'Sie haben alle Nachrichten angesehen.',
  'component.globalHeader.event': 'Ereignis',
  'component.globalHeader.event.empty': 'Sie haben alle Ereignisse angesehen.',
  'component.noticeIcon.clear': 'Löschen',
  'component.noticeIcon.cleared': 'Gelöscht',
  'component.noticeIcon.empty': 'Keine Benachrichtigungen',
  'component.noticeIcon.view-more': 'Mehr anzeigen',
};
